(function () {
  function getHeaderHeight() {
    if (
      typeof window !== "undefined" &&
      typeof window.headerHeight === "number" &&
      !isNaN(window.headerHeight)
    ) {
      return window.headerHeight;
    }
    var value = getComputedStyle(document.documentElement)
      .getPropertyValue("--header-height")
      .trim();
    if (!value) return 0;
    var num = parseFloat(value, 10);
    if (value.indexOf("px") !== -1) return isNaN(num) ? 0 : num;
    return isNaN(num) ? 0 : num;
  }

  function updateStickyStepsTops(section) {
    var titleWraps = section.querySelectorAll(".sticky-steps__title-wrap");
    if (!titleWraps.length) return;

    var headerHeight = getHeaderHeight();
    var accumulatedHeight = 0;

    for (var i = 0; i < titleWraps.length; i++) {
      var el = titleWraps[i];
      var top = headerHeight + accumulatedHeight - 2;
      el.style.top = top + "px";
      accumulatedHeight += el.offsetHeight;
    }
  }

  function scrollToTitle(button) {
    var blockId = button.getAttribute("data-sticky-steps-target");
    if (!blockId) return;

    var section = button.closest(".sticky-steps");
    if (!section) return;

    var anchorEl = section.querySelector(
      '[id="sticky-steps-anchor-' + blockId + '"]'
    );
    if (!anchorEl) return;

    var headerHeight = getHeaderHeight();
    var titleWrap = anchorEl.nextElementSibling;
    var titleHeight = titleWrap ? titleWrap.offsetHeight : 0;
    var rect = anchorEl.getBoundingClientRect();
    var currentScroll =
      window.lenis && typeof window.lenis.scroll === "number"
        ? window.lenis.scroll
        : window.pageYOffset || document.documentElement.scrollTop;
    var targetScrollY =
      rect.top + currentScroll - headerHeight - titleHeight - 50;
    targetScrollY = Math.max(0, Math.round(targetScrollY));

    if (window.lenis && typeof window.lenis.scrollTo === "function") {
      window.lenis.scrollTo(targetScrollY, {
        duration: 1.2,
        easing: function (t) {
          return Math.min(1, 1.001 - Math.pow(2, -10 * t));
        },
      });
    } else {
      window.scrollTo({ top: targetScrollY, behavior: "smooth" });
    }
  }

  function initStickySteps() {
    var sections = document.querySelectorAll(".sticky-steps");
    sections.forEach(function (section) {
      updateStickyStepsTops(section);

      var titleButtons = section.querySelectorAll(
        ".sticky-steps__title[data-sticky-steps-target]"
      );
      titleButtons.forEach(function (btn) {
        btn.removeEventListener("click", handleTitleClick);
        btn.addEventListener("click", handleTitleClick);
      });
    });
  }

  function handleTitleClick(ev) {
    ev.preventDefault();
    scrollToTitle(ev.currentTarget);
  }

  function onLoad() {
    initStickySteps();
    setTimeout(initStickySteps, 0);
    requestAnimationFrame(function () {
      initStickySteps();
    });

    window.addEventListener("resize", function () {
      initStickySteps();
    });

    if (typeof ResizeObserver !== "undefined") {
      document.querySelectorAll(".sticky-steps").forEach(function (section) {
        var ro = new ResizeObserver(function () {
          updateStickyStepsTops(section);
        });
        var titleWraps = section.querySelectorAll(".sticky-steps__title-wrap");
        titleWraps.forEach(function (el) {
          ro.observe(el);
        });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onLoad);
  } else {
    onLoad();
  }
})();
